import { Location } from 'react-router-dom';
import { DATA_LOCKER_LANDING_PAGE_TAB } from '@/consts/searchKeys';

const getPathnameAndSearch = (route: string) => route.split('?') ?? [];

const getSectionFromRoute = (route: string) => {
  const [withoutParams] = getPathnameAndSearch(route);
  return withoutParams.split('/').at(2);
};

export const isSideNavSectionActive = (currentPathname: string, linkPathname: string) => {
  const currentSection = getSectionFromRoute(currentPathname);
  const linkSection = getSectionFromRoute(linkPathname);
  return linkSection === currentSection;
};

const isDataLockerPage = (path: string) => {
  const dataLockerLandingPathMatch = /^\/\w{2}\/data-locker/;
  return dataLockerLandingPathMatch.test(path);
};

const getDataLockerTab = (search: string) => new URLSearchParams(search).get(DATA_LOCKER_LANDING_PAGE_TAB);

// return the data locker 'sub-page'. e.g. for /en/data-locker/foo would return 'foo'
const getDLSubPage = (route: string) => route.split('/')[3];

export const isSideNavPageActive = (location: Location, route: string | undefined) => {
  const { pathname, search: pageSearchParams } = location;
  if (!route) return false;

  if (isDataLockerPage(route) && isDataLockerPage(pathname)) {
    // Correctly apply which tab is active when on the data locker landing page as they all use the same route just with
    // a search param.
    const pathEntity = getDataLockerTab(pageSearchParams);
    if (pathEntity) return `${pathname}${pageSearchParams}` === route;

    // Match data locker pages against their corresponding landing-page tab
    const [_, routeSearchParams] = getPathnameAndSearch(route);
    const routeEntity = getDataLockerTab(routeSearchParams);
    if (routeEntity) return routeEntity === getDLSubPage(pathname);

    return false;
  }

  return pathname === route;
};
